/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { AchCompanyModelDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class AchCompaniesClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags AchCompanies
   * @name AchCompaniesSearch
   * @summary Search for Ach Companies for passed criteria.
   * @request GET:/achCompanies/search
   */
  achCompaniesSearch = (
    query?: {
      /** Contains search on Company Name */
      companyName?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AchCompanyModelDto, any>({
      path: `/achCompanies/search`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AchCompanies
   * @name AchCompaniesSearchByCompanyId
   * @summary Search for Ach Companies for passed criteria.
   * @request GET:/achCompanies/{companyId}/search
   */
  achCompaniesSearchByCompanyId = (
    companyId: number,
    query?: {
      /** Contains search on Company Name */
      companyName?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AchCompanyModelDto[], any>({
      path: `/achCompanies/${companyId}/search`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
}
